/**
 * `AddAccount` (frame 86:2): its own catalogue,
 * kept out of the list and account screens' so a change to one never touches the other.
 */
import { defineCatalogue } from '../../../i18n';
export const addAccountCatalogue = defineCatalogue(
  {
    trigger: 'Adicionar conta',
    title: 'Adicionar conta monitorada',
    'account.label': 'Conta',
    'account.placeholder': 'instagram.com/usuario',
    'account.required': 'Informe a conta a acompanhar.',
    'collection.label': 'Coleta',
    'collection.profilesLink': 'Perfis da organização',
    'collection.profile': 'Perfil de coleta',
    'collection.profile.required': 'Escolha um perfil de coleta.',
    'collection.summary': 'Resumo da coleta',
    'collection.chip.noCollection': 'sem coleta',
    'collection.chip.POST': 'Publicações',
    'collection.chip.REEL': 'Reels',
    'collection.chip.STORY': 'Stories',
    'alignment.label': 'Alinhamento',
    'alignment.required': 'Escolha o alinhamento desta conta.',
    'alignment.ALLY': 'Aliado',
    'alignment.NEUTRAL': 'Neutro',
    'alignment.ADVERSARY': 'Adversário',
    'scope.label': 'Coleta',
    'scope.all': 'Coleta completa — todas as publicações',
    'scope.related': 'Só publicações relacionadas à campanha',
    'scope.all.hint': 'Traz comentários, curtidas e métricas de toda publicação desta conta.',
    submit: 'Adicionar',
    cancel: 'Cancelar',
    'error.duplicate': 'Esta conta já é acompanhada nesta campanha.',
    'error.badHandle': 'Não foi possível reconhecer essa conta.',
    'error.profileMissing': 'Este perfil não está no catálogo da organização.',
    'error.forbidden': 'Só um administrador da organização pode adicionar contas.',
    'error.generic': 'Não foi possível adicionar a conta.',
  },
  {
    trigger: 'Add account',
    title: 'Add a monitored account',
    'account.label': 'Account',
    'account.placeholder': 'instagram.com/handle',
    'account.required': 'Enter the account to track.',
    'collection.label': 'Collection',
    'collection.profilesLink': "Organisation's profiles",
    'collection.profile': 'Collection profile',
    'collection.profile.required': 'Choose a collection profile.',
    'collection.summary': 'Collection summary',
    'collection.chip.noCollection': 'no collection',
    'collection.chip.POST': 'Posts',
    'collection.chip.REEL': 'Reels',
    'collection.chip.STORY': 'Stories',
    'alignment.label': 'Alignment',
    'alignment.required': 'Choose this account’s alignment.',
    'alignment.ALLY': 'Ally',
    'alignment.NEUTRAL': 'Neutral',
    'alignment.ADVERSARY': 'Adversary',
    'scope.label': 'Collection',
    'scope.all': 'Full collection — every post',
    'scope.related': 'Only posts related to the campaign',
    'scope.all.hint': 'Pulls comments, likers and metrics for every post of this account.',
    submit: 'Add',
    cancel: 'Cancel',
    'error.duplicate': 'This account is already tracked in this campaign.',
    'error.badHandle': 'This account could not be recognised.',
    'error.profileMissing': "This profile is not in the organisation's catalogue.",
    'error.forbidden': 'Only an organisation administrator can add accounts.',
    'error.generic': 'The account could not be added.',
  },
);
export const aat = addAccountCatalogue.t;
export const aap = addAccountCatalogue.plural;
